import { DisplayError } from 'components/DataFallback'
import type { DataFallbackConfigType } from 'components/DataFallback/types'
import type { MCWithParams } from 'components/uiKit/Modal'
import Modal, { ModalBody } from 'components/uiKit/Modal'

const ModalRedirect: MCWithParams<DataFallbackConfigType, void> = ({ onClose, params }) => (
  <Modal name='redirect'>
    <ModalBody sizeAutoCapable>
      <DisplayError {...params} onClose={onClose} />
    </ModalBody>
  </Modal>
)

export default ModalRedirect
